<script>
import appConfig from '@/app.config'
import McButton from '@/components/McButton'
import PageHeader from '@/components/page-header'
import { Helper } from '@/mixin/helper'
import Layout from '@/router/layouts/main'

import { MixPanel } from '@/mixin/mixpanel'

import LoadingSkeleton from './LoadingSkeleton.vue'
import { GET_GEOFENCES_FILTER } from '@/services/api/master/geofence'
import {
  CREATE_RITAGE_GEOFENCE,
  GET_RITAGE_GEOFENCE,
  UPDATE_RITAGE_GEOFENCE,
} from '@/services/api/master/ritage'
import { gmapApi } from 'vue2-google-maps'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Ritage',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    LoadingSkeleton,
  },
  mixins: [MixPanel, Helper],
  apollo: {
    ritageGeofence: {
      query: GET_RITAGE_GEOFENCE,
      fetchPolicy: 'no-cache',
      variables() {
        const [geofenceLoadingId, geofenceDumpingId] = this.id.split('-')
        return {
          filter: {
            geofenceLoadingId: parseInt(geofenceLoadingId),
            geofenceDumpingId: parseInt(geofenceDumpingId),
          },
        }
      },
      // Disable the query
      skip() {
        return this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) {
          this.loading = true
          this.ritageGeofence.ritageGeofence = data.ritageGeofence.ritageGeofence
          this.userLogging('Access', this.$route, this.ritageGeofence.ritageGeofence.ritageName)
          setTimeout(() => {
            this.initEditPage()
            this.loading = false
          }, 800)
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      isSubmit: false,
      formErrors: {},
      form: {
        ritageName: '',
        startGeofence: null,
        endGeofence: null,
      },
      fullObject: {
        startGeofence: {},
        endGeofence: {},
      },
      map: null,
      loadingGeofence: null,
      dumpingGeofence: null,
      id: this.$route.params.id || '',
      ritageGeofence: {
        ritageGeofence: {},
      },
    }
  },
  computed: {
    google: gmapApi,
    title() {
      return this.$route.params.id === undefined
        ? this.$t('master.form.ritage.createRitageForm')
        : this.$t('master.form.ritage.detailRitageForm')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('menuitems.masterData.list.ritage'),
          to: '/master/ritage',
        },
        {
          text:
            this.$route.params.id === undefined
              ? this.$t('master.form.ritage.createRitageForm')
              : this.form.location_name,
          active: true,
        },
      ]
    },
    resourcefulQuery() {
      return {
        loadingGeofence: async (opts) => {
          let result = {}

          const { limit, page, ...otherOpt } = opts
          const response = await this.$apollo.query({
            query: GET_GEOFENCES_FILTER,
            variables: {
              filter: {
                orderBy: JSON.stringify({ fenceName: 'asc' }),
                pagination: {
                  page: page,
                  show: limit,
                },
                category: ['Loading'],
                ...otherOpt,
              },
            },
          })
          let res = { ...response.data.geofencesFilter.geofencesFilterPaginated }
          const optionsObj = res.data.map((item) => {
            return {
              key: item.geofenceId,
              label: item.fenceName,
              polygon: item.polyData,
              circle: item.circData,
            }
          })

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: optionsObj,
            },
          }

          return result
        },
        dumpingGeofence: async (opts) => {
          let result = {}

          const { limit, page, ...otherOpt } = opts
          const response = await this.$apollo.query({
            query: GET_GEOFENCES_FILTER,
            variables: {
              filter: {
                orderBy: JSON.stringify({ fenceName: 'asc' }),
                pagination: {
                  page: page,
                  show: limit,
                },
                category: ['Dumping'],
                ...otherOpt,
              },
            },
          })
          let res = { ...response.data.geofencesFilter.geofencesFilterPaginated }
          const optionsObj = res.data.map((item) => {
            return {
              key: item.geofenceId,
              label: item.fenceName,
              polygon: item.polyData,
              circle: item.circData,
            }
          })

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: optionsObj,
            },
          }

          return result
        },
      }
    },
  },
  async mounted() {
    const self = this
    await this.$refs.MapAddress.$mapPromise.then((map) => {
      self.map = map
    })
  },
  methods: {
    initEditPage() {
      this.form.ritageName = this.ritageGeofence.ritageGeofence.ritageName
      this.form.startGeofence = this.ritageGeofence.ritageGeofence.geofenceLoading.geofenceId
      this.form.endGeofence = this.ritageGeofence.ritageGeofence.geofenceDumping.geofenceId
      this.fullObject.loadingGeofence = {
        key: this.ritageGeofence.ritageGeofence.geofenceLoading.geofenceId,
        label: this.ritageGeofence.ritageGeofence.geofenceLoading.fenceName,
        polygon: this.ritageGeofence.ritageGeofence.geofenceLoading.polyData,
        circle: this.ritageGeofence.ritageGeofence.geofenceLoading.circData,
      }
      this.fullObject.dumpingGeofence = {
        key: this.ritageGeofence.ritageGeofence.geofenceDumping.geofenceId,
        label: this.ritageGeofence.ritageGeofence.geofenceDumping.fenceName,
        polygon: this.ritageGeofence.ritageGeofence.geofenceDumping.polyData,
        circle: this.ritageGeofence.ritageGeofence.geofenceDumping.circData,
      }
      this.drawLoadingGeofence()
      this.drawDumpingGeofence()
    },
    toCancel() {
      this.$router.push({ name: 'Master Ritage' })
    },
    drawLoadingGeofence() {
      if (this.fullObject.loadingGeofence.polygon) {
        this.setPolyGeofence(this.fullObject.loadingGeofence.polygon, 'loading')
      } else if (this.fullObject.loadingGeofence.circle) {
        this.setCircleGeofence(this.fullObject.loadingGeofence.circle, 'loading')
      }
    },
    drawDumpingGeofence() {
      if (this.fullObject.dumpingGeofence.polygon) {
        this.setPolyGeofence(this.fullObject.dumpingGeofence.polygon, 'dumping')
      } else if (this.fullObject.dumpingGeofence.circle) {
        this.setCircleGeofence(this.fullObject.dumpingGeofence.circle, 'dumping')
      }
    },
    updateLoading($event) {
      this.fullObject.loadingGeofence = $event
      this.drawLoadingGeofence()
    },
    updateDumping($event) {
      this.fullObject.dumpingGeofence = $event
      this.drawDumpingGeofence()
    },
    setCircleGeofence(circData, type) {
      let circDataReplaced = circData.replace('<', '').replace('>', '')
      let circleArray = circDataReplaced.split('),')
      this.form.radius = circleArray[1]
      this.form.latLang = circleArray[0] + ')'
      let latLong = circleArray[0].replace('(', '').split(',')
      this.initMapCircle(latLong, type)
    },
    setPolyGeofence(polyData, type) {
      let polyArray = polyData.split('),')
      let newPoly = []
      polyArray.forEach(function (item) {
        newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
      })
      this.initMapPoly(newPoly, type)
    },
    validate() {
      if (this.$refs.formRef.hasErrors) {
        this.$refs.formRef.showErrors()
        return false
      }
      return true
    },
    initMapCircle(places = [], type) {
      if (type == 'loading') {
        if (this.loadingGeofence != null) {
          this.loadingGeofence.setMap(null)
          this.loadingGeofence = null
        }

        this.loadingGeofence = new this.google.maps.Circle({
          strokeColor: '#0D4491',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#1C74DA',
          fillOpacity: 0.35,
          map: this.map,
          radius: parseInt(this.form.radius),
          editable: true,
          draggable: true,
        })

        this.loadingGeofence.setMap(null)
        this.loadingGeofence.setMap(this.map)

        this.loadingGeofence.setCenter({
          lat: parseFloat(places[0]),
          lng: parseFloat(places[1]),
        })

        this.map.fitBounds(this.loadingGeofence.getBounds())
      } else if (type == 'dumping') {
        if (this.dumpingGeofence != null) {
          this.dumpingGeofence.setMap(null)
          this.dumpingGeofence = null
        }

        this.dumpingGeofence = new this.google.maps.Circle({
          strokeColor: '#0D4491',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#1C74DA',
          fillOpacity: 0.35,
          map: this.map,
          radius: parseInt(this.form.radius),
          editable: true,
          draggable: true,
        })

        this.dumpingGeofence.setMap(null)
        this.dumpingGeofence.setMap(this.map)

        this.dumpingGeofence.setCenter({
          lat: parseFloat(places[0]),
          lng: parseFloat(places[1]),
        })

        this.map.fitBounds(this.dumpingGeofence.getBounds())
      }
    },

    initMapPoly(places = [], type) {
      if (places.length === 0) return
      if (type == 'loading') {
        if (this.loadingGeofence != null) {
          this.loadingGeofence.setMap(null)
          this.loadingGeofence = null
        }

        let coords = []

        if (places.length === 1) {
          const lat = parseFloat(places[0][0])
          const lng = parseFloat(places[0][1])

          coords = [
            {
              lat: lat - 1 / 1000,
              lng: lng + 1 / 1000,
            },
            {
              lat: lat - 1 / 1000,
              lng: lng - 1 / 1000,
            },
            {
              lat: lat + 1 / 1000,
              lng: lng - 1 / 1000,
            },
            {
              lat: lat + 1 / 1000,
              lng: lng + 1 / 1000,
            },
          ]
        } else {
          places.forEach(function (item) {
            coords.push({
              lat: parseFloat(item[0]),
              lng: parseFloat(item[1]),
            })
          })
        }

        // Construct the polygon.
        this.loadingGeofence = new this.google.maps.Polygon({
          paths: coords,
          strokeColor: '#0D4491',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#1C74DA',
          fillOpacity: 0.35,
          editable: true,
          draggable: true,
        })
        this.loadingGeofence.setMap(null)
        this.loadingGeofence.setMap(this.map)

        const bounds = new this.google.maps.LatLngBounds()
        coords.forEach((item) => {
          bounds.extend({ lat: parseFloat(item.lat), lng: parseFloat(item.lng) })
        })

        this.map.fitBounds(bounds)
      } else if (type == 'dumping') {
        if (this.dumpingGeofence != null) {
          this.dumpingGeofence.setMap(null)
          this.dumpingGeofence = null
        }

        let coords = []

        if (places.length === 1) {
          const lat = parseFloat(places[0][0])
          const lng = parseFloat(places[0][1])

          coords = [
            {
              lat: lat - 1 / 1000,
              lng: lng + 1 / 1000,
            },
            {
              lat: lat - 1 / 1000,
              lng: lng - 1 / 1000,
            },
            {
              lat: lat + 1 / 1000,
              lng: lng - 1 / 1000,
            },
            {
              lat: lat + 1 / 1000,
              lng: lng + 1 / 1000,
            },
          ]
        } else {
          places.forEach(function (item) {
            coords.push({
              lat: parseFloat(item[0]),
              lng: parseFloat(item[1]),
            })
          })
        }

        // Construct the polygon.
        this.dumpingGeofence = new this.google.maps.Polygon({
          paths: coords,
          strokeColor: '#0D4491',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#1C74DA',
          fillOpacity: 0.35,
          editable: true,
          draggable: true,
        })
        this.dumpingGeofence.setMap(null)
        this.dumpingGeofence.setMap(this.map)

        const bounds = new this.google.maps.LatLngBounds()
        coords.forEach((item) => {
          bounds.extend({ lat: parseFloat(item.lat), lng: parseFloat(item.lng) })
        })

        this.map.fitBounds(bounds)
      }
    },
    async toSave() {
      if (!this.validate()) {
        return
      }
      this.isSubmit = true
      if (this.id !== undefined && this.id != '') {
        const response = await this.$apollo.mutate({
          mutation: UPDATE_RITAGE_GEOFENCE,
          variables: {
            input: {
              newData: {
                geofenceDumpingId: this.form.endGeofence,
                geofenceLoadingId: this.form.startGeofence,
                ritageName: this.form.ritageName,
              },
              oldData: {
                geofenceDumpingId: this.ritageGeofence.ritageGeofence.geofenceDumping.geofenceId,
                geofenceLoadingId: this.ritageGeofence.ritageGeofence.geofenceLoading.geofenceId,
                ritageName: this.ritageGeofence.ritageGeofence.ritageName,
              },
            },
          },
        })
        if (response.data.updateRitageGeofence.isSuccessful) {
          this.$mcToast.success(this.$t('master.form.ritage.updateSuccess'))
        } else {
          this.$mcToast.error(response.data.updateRitageGeofence.message)
        }
      } else {
        const response = await this.$apollo.mutate({
          mutation: CREATE_RITAGE_GEOFENCE,
          variables: {
            input: {
              ritageName: this.form.ritageName,
              geofenceLoadingId: this.form.startGeofence,
              geofenceDumpingId: this.form.endGeofence,
            },
          },
        })
        if (response.data.createRitageGeofence.isSuccessful) {
          this.$mcToast.success(this.$t('master.form.ritage.createSuccess'))
          this.$router.push({ name: 'Master Ritage' })
        } else {
          this.$mcToast.error(response.data.createRitageGeofence.message)
        }
      }

      this.isSubmit = false
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            size="medium"
            class="mx-2"
            variant="secondary"
            :text="$t('global.cancel')"
            icon="icon-outline_close"
            @click="toCancel"
          />
          <McButton
            size="medium"
            variant="primary"
            :disabled="isSubmit"
            :text="$t('global.save')"
            icon="icon-outline_save"
            @click="toSave"
          />
        </div>
      </div>
    </div>
    <FormulateForm ref="formRef" v-model="form" :errors="formErrors">
      <b-row>
        <b-col sm="12" md="7">
          <b-card>
            <b-row class="mc-form--address-search mb-2">
              <!-- TODO: disabled button on map background color still same as not disabled button -->
              <b-col md="12">
                <GmapMap
                  id="map"
                  ref="MapAddress"
                  :center="$store.state.map.center"
                  :zoom="parseFloat($store.state.map.zoom)"
                  class="mc-map-address mt-2"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col sm="12" md="5">
          <b-card>
            <h4 class="card-title mb-4">
              {{ $t('master.form.ritage.createRitageForm') }}
            </h4>
            <template>
              <b-skeleton-wrapper :loading="loading">
                <template #loading>
                  <LoadingSkeleton />
                </template>

                <b-row>
                  <div class="mb-3">
                    <FormulateInput
                      v-model="form.ritageName"
                      :placeholder="$t('master.form.ritage.ritageName')"
                      type="text"
                      help="required"
                      :validation="[['bail'], ['required'], ['between', 0, 255, 'length']]"
                      :validation-messages="{
                        required: `${$t('master.form.ritage.ritageName')} ${$t(
                          'global.validation.required'
                        )}`,
                        between: $t('setting.list.company.formAlert.ritageLimit'),
                      }"
                    />
                  </div>
                </b-row>

                <b-row>
                  <div class="mb-3">
                    <FormulateInput
                      v-model="form.startGeofence"
                      type="select-resourceful-v2"
                      help="required"
                      :placeholder="`${$t('global.form.select')} ${$t(
                        'master.form.ritage.startGeofence'
                      )}`"
                      :label="$t('master.form.ritage.startGeofence')"
                      validation="required"
                      :validation-messages="{
                        required: `${$t('master.form.ritage.startGeofence')} ${$t(
                          'global.validation.required'
                        )}`,
                      }"
                      :optionsGetter="resourcefulQuery.loadingGeofence"
                      :taggable="false"
                      :multiple="false"
                      trackBy="key"
                      :optionLabelFn="({ item }) => item.label"
                      :fullObject="fullObject.loadingGeofence"
                      @update:fullObject="updateLoading"
                    />
                  </div>
                </b-row>

                <b-row>
                  <div class="mb-3">
                    <FormulateInput
                      v-model="form.endGeofence"
                      type="select-resourceful-v2"
                      help="required"
                      :placeholder="`${$t('global.form.select')} ${$t(
                        'master.form.ritage.endGeofence'
                      )}`"
                      :label="$t('master.form.ritage.endGeofence')"
                      validation="required"
                      :validation-messages="{
                        required: `${$t('master.form.ritage.endGeofence')} ${$t(
                          'global.validation.required'
                        )}`,
                      }"
                      :optionsGetter="resourcefulQuery.dumpingGeofence"
                      :taggable="false"
                      :multiple="false"
                      trackBy="key"
                      :optionLabelFn="({ item }) => item.label"
                      :fullObject="fullObject.dumpingGeofence"
                      @update:fullObject="updateDumping"
                    />
                  </div>
                </b-row>
              </b-skeleton-wrapper>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </FormulateForm>
  </Layout>
</template>
